export default "__VITE_ASSET__YjupTUy___"